<template>
  <a-modal
    title="风险测评信息"
    :visible="visible"
    :width="800"
    @ok="handleOk"
    @cancel="handleVisible"
    style="height: 500px"
  >
    <div class="answerDetails">
      <ul>
        <li>
          <label>客户名称:</label>
          <span>{{ detailsInfo.questionnaireName }}</span>
        </li>
        <li>
          <label>测评时间:</label>
          <span>{{ detailsInfo.createTime }}</span>
        </li>
        <li>
          <label>测评分数:</label>
          <span>{{ detailsInfo.totalScore }}</span>
        </li>
        <li>
          <label>测评结果:</label>
          <span>{{ detailsInfo.riskLevel_dictText }}</span>
        </li>
      </ul>
      <p class="title">测评明细</p>
      <a-table :columns="columns" :data-source="answerList">
        <span slot="answerContent" slot-scope="text" v-html="text"> </span>
      </a-table>
    </div>
  </a-modal>
</template>
<script>
const columns = [
  {
    title: '题目序号',
    dataIndex: 'index',
    key: 'index',
    align: 'center',
    width: 200,
    customRender: (text, record, index) => `${index + 1}`
  },
  {
    title: '答案',
    dataIndex: 'answerContent',
    scopedSlots: { customRender: 'answerContent' }, // scopedSlots 这个属性很关键
    key: 'answerContent',
    ellipsis: true,
    width: 300
  },
  {
    title: '分数',
    dataIndex: 'score',
    key: 'score'
  }
];
import {
  getAnswerList,
  addProductToGroup,
  batchBindProductToGroup
} from '@/api/product';
export default {
  data() {
    return {
      detailsInfo: {},
      columns,
      answerList: [],

      visible: false
    };
  },
  created() {},
  methods: {
    handleVisible() {
      this.visible = !this.visible;
    },

    handleOk() {
      let that = this;
      let params = {
        fundCodeList: that.fundCode,
        fundGroupId: that.groupId
      };
      if (!this.isBath) {
        addProductToGroup(params).then(res => {
          if (res.success) {
            that.$message.success(res.message);
            this.visible = false;
            this.$emit('callback');
          } else {
            that.$message.error(res.message);
          }
        });
      } else {
        batchBindProductToGroup(params).then(res => {
          if (res.success) {
            that.$message.success(res.message);
            this.visible = false;
            this.groupId = '';
            this.$emit('callback');
          } else {
            that.$message.error(res.message);
          }
        });
      }
    },
    initGroupList(record) {
      this.detailsInfo = record;
      getAnswerList(record.id).then(res => {
        if (res.success) {
          this.answerList =
            res.result && res.result.records ? res.result.records : [];
        } else {
          this.$message.error(res.message);
        }
      });
    }
  }
};
</script>
<style scoped lang="less">
/deep/.ant-modal-content {
  height: 700px;
}
.answerDetails {
  height: 540px;
  overflow: auto;
  ul {
    li {
      list-style: none;
      line-height: 32px;
      span {
        padding-left: 10px;
      }
    }
  }
  p.title {
    font-weight: 700;
  }
}
</style>
